/**
 * @description: api总览
 * normalApi 通用api
 * deepApi promise回调api
 */

const web = 'web' // web

const h5 = 'h5' // 独立版

const xbb = [web, h5]

export default {
  normalApi: {
    xbbRecordStart: [h5],
    xbbRecordStop: [h5],
    xbbRecordPause: [h5],
    xbbRecordResume: [h5],
    xbbGetLocation: [h5],
    xbbLocalStorageSet: xbb,
    xbbLocalStorageGet: xbb,
    xbbLocalStorageRemove: xbb,
    xbbLocalStorageClear: xbb,
    h5GetProperty: [h5],
    xbbOpenLink: [h5],
    h5DownLoadFile: [h5],
    h5InstallApp: [h5],
    xbbDial: [h5]
  },
  deepApi: {},
  envFunApi: {
    h5HandlePlusready: [h5],
    h5GoBack: [h5],
    throttleH5ResourceUpgrade: [h5]
  }
}
